module.exports = __webpack_public_path__ + "img/agrégat-compacté-md.eba9c2ca.jpg";